export const QuillCustomClasses = {
    custom_image_sizes_class: 'imageCustomization'
}

export const ImageActionsIds = {
    smallId: 'smallAction',
    fitId: 'fitAction',
    largeId: 'largeAction'
}